import { lazy } from "react";

export { SIGN_DOCUMENT_TYPES_LIST_PATH } from "./sign-document-types-list-path";
export const SignDocumentTypesListPage = lazy(
  () => import("./sign-document-types-list-page"),
);
